<template>
  <div class="faq">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row">
              <div class="col-sm-12">
                <h3 class="page-title">FAQ</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">FAQ</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div class="faq-card">
             <div class="card" v-show="false">
              <div class="card-header">
                <h4 class="card-title">
                  <a class="collapsed" data-toggle="collapse" href="#interactivemessage">Apakah pesan interaktif didukung oleh semua perangkat dan tipe akun?</a>
                </h4>
              </div>
              <div id="interactivemessage" class="card-collapse collapse">
                <div class="card-body">
                  <p>
                    Berikut informasi terkait pengiriman pesan jenis button, list dan template.
                    <br />
                    <img src="https://s3-id-jkt-1.kilatstorage.id/aphrodite.enusoft.id/media/static/interactivemsg-support.png" style="width:100%;">
                  </p>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">
                  <a class="collapsed" data-toggle="collapse" href="#collapseOne">Apa itu Waajo?</a>
                </h4>
              </div>
              <div id="collapseOne" class="card-collapse collapse">
                <div class="card-body">
                  <p>Waajo adalah whatsapp Serverless API yang berfungsi untuk mengirimkan pesan Instant Messaging otomatis. Jadi kamu bisa integrasikan aplikasimu dengan Waajo untuk mengirimkan pesan lewat Whatsapp.</p>
                </div>
              </div>
            </div>           
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">
                  <a
                    class="collapsed"
                    data-toggle="collapse"
                    href="#collapseTwo"
                  >Untuk berikirim pesan menggunakan nomor siapa?</a>
                </h4>
              </div>
              <div id="collapseTwo" class="card-collapse collapse">
                <div class="card-body">
                  <p>Untuk mengirim pesan lewat API dan juga aplikasi Waajo, kamu bisa gunakan nomor kamu sendiri. Caranya cukup scan barcode di linked device kamu.</p>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">
                  <a
                    class="collapsed"
                    data-toggle="collapse"
                    href="#collapseThree"
                  >Apakah ini official partner API Whatsapp?</a>
                </h4>
              </div>
              <div id="collapseThree" class="card-collapse collapse">
                <div class="card-body">
                  <p>Tidak, kami adalah penyedia layanan mandiri yang mampu mengotomatisasi aplikasi WA guna mengirim pesan dari channel/toko kamu. Selain itu kami juga fokus menyediakan layanan API Whatsapp.</p>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">
                  <a
                    class="collapsed"
                    data-toggle="collapse"
                    href="#collapseFour"
                  >Apakah saya dapat mengirim broadcast pesan?</a>
                </h4>
              </div>
              <div id="collapseFour" class="card-collapse collapse">
                <div class="card-body">
                  <p>Kami menyediakan fasilitas broadcast pesan, namun sebelum mengirimkan pesan broadcast ini, kami sarankan nomor kamu sudah tersimpan di nomor penerima agar tidak dianggap sebagai spam.</p>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">
                  <a
                    class="collapsed"
                    data-toggle="collapse"
                    href="#collapseFive"
                  >Bisakah saya tetap menggunakan Whatsapp Web?</a>
                </h4>
              </div>
              <div id="collapseFive" class="card-collapse collapse">
                <div class="card-body">
                  <p>Tetap bisa, tidak perlu khawatir.</p>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">
                  <a class="collapsed" data-toggle="collapse" href="#collapseSix">
                    Apa itu
                    <i style="font-size:10px;" class="badge badge-danger">Beta</i> version?
                  </a>
                </h4>
              </div>
              <div id="collapseSix" class="card-collapse collapse">
                <div class="card-body">
                  <p>
                    Fitur ini belum stabil, terutama di device IOS. Tetapi kamu tidak perlu khawatir, tim Riset
                    kami sedang bekerja keras untuk menyempurnakannya.
                  </p>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">
                  <a class="collapsed" data-toggle="collapse" href="#collapseSeven">
                    Berapa lama Waajo menyimpan data pesan saya?
                  </a>
                </h4>
              </div>
              <div id="collapseSeven" class="card-collapse collapse">
                <div class="card-body">
                  <p>
                   Waajo akan menyimpan data pesan masuk atau keluar maksimal sekitar 14 - 30 hari.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "faq"
};
</script>


// WEBPACK FOOTER //
// src/views/page/faq.vue